import { render } from "./WorkloadPorts.vue?vue&type=template&id=5bdb825a&scoped=true"
import script from "./WorkloadPorts.vue?vue&type=script&lang=js"
export * from "./WorkloadPorts.vue?vue&type=script&lang=js"

import "./WorkloadPorts.vue?vue&type=style&index=0&id=5bdb825a&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdb825a"]])

export default __exports__